import { createFileRoute, redirect } from '@tanstack/react-router';
import { isAccountMissingError } from '@/api/errors';
import { safeAsync } from '@/helpers/errors/safeAsync';
import { resolveAccount, resolveClusterRouteEntrypoint } from '@/router/resolvers/user';
import { accountIdUrlParam } from '../accounts/$accountId/route.hooks';

export const Route = createFileRoute('/_authenticated/_dashboard/auth/callback')({
  staticData: {
    domain: 'auth',
  },
  beforeLoad: async ({ context, search }) => {
    const [error, account] = await safeAsync(resolveAccount(context));

    if (error) {
      // If the user has no accounts, redirect to the get-started page.
      if (isAccountMissingError(error)) {
        throw redirect({ to: '/get-started', search, replace: true });
      }
      throw error;
    }

    await resolveClusterRouteEntrypoint({ ...context, accountId: accountIdUrlParam.parse(account.id), search });
  },
});
